<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="货款补扣单号" name="sup_deduct_number"></c-form-item>
					<c-form-item type="select" label="补扣类型" name="type" :options="Type2"></c-form-item>
                    <c-form-item type="input" label="授权代码" name="login_name"></c-form-item>
                    <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
                    <c-form-item type="datetime" label="申请时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="checkbox" label="状态" name="state" :options="State" ></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button color="sys" power="b_member_account_supdeduct_edit"  @click="add">申请补扣货款</c-button>
                <c-button power="b_member_account_supdeduct_import" @click="importSupdeduct()" hollow icon="upload">批量导入充值</c-button>
			</m-operate>
			
			<c-table ref="table" code="member_account_supdeduct_list">
				<c-table-column
					label="货款补扣单号"
					name="sup_deduct_number"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="state"
					width="70"
				>
					<template v-slot="{data}">
						<span style="color:red" v-if="data.state==0">{{stateName[data.state]}}</span>
						<span style="color:dodgerblue" v-if="data.state==1">{{stateName[data.state]}}</span>
						<span style="color:dodgerblue" v-if="data.state==2">{{stateName[data.state]}}</span>
						<span style="color:green" v-if="data.state==3">{{stateName[data.state]}}</span>
						<span style="color:gray" v-if="data.state==4">{{stateName[data.state]}}</span>
					</template>
				</c-table-column>

				<c-table-column
					label="类型"
					name="type"
					width="50"
				>
					<template v-slot="{data}">
						<span style="color:dodgerblue"  v-if="data.type=='补款'">{{data.type}}</span>
						<span style="color:green"  v-if="data.type=='充值'">{{data.type}}</span>
						<span style="color:red"  v-if="data.type=='扣款'">{{data.type}}</span>
					</template>
				</c-table-column>
		
				<c-table-column
					label="金额"
					name="money"
					width="110"
				>
					<template v-slot="{data}">
						<span style="color:dodgerblue" v-if="data.money && data.money>0">￥{{data.money.toFixed(2)}}</span>
						<span style="color:red" v-else-if="data.money && data.money<0"> ￥{{data.money.toFixed(2)}}</span>
						<span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="授权代码"
					name="login_name"
					width="100"
				>
                    <template v-slot="{data}">
                        <span v-if="data.login_name && data.login_name!=''">{{data.login_name}}</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

				<c-table-column
					label="会员手机号"
					name="user_manage_mobilephone"
					width="125"
				></c-table-column>

				<c-table-column
					label="会员昵称"
					name="nick_name"
					width="120"
				>
					<template v-slot="{data}">
						<span v-if="data.nick_name && data.nick_name!=''">{{data.nick_name}}</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="会员等级"
					name="user_level_name"
					width="100"
				>
				</c-table-column>

				<c-table-column
					label="备注"
					name="remark"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="申请时间"
					name="create_date"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="申请人姓名"
					name="create_user_realname"
					width="120"
				></c-table-column>
		
<!--				<c-table-column
					label="审批人姓名"
					name="approval_user_realname"
					width="120"
				></c-table-column>

				<c-table-column
					label="审批时间"
					name="approval_date"
					width="150"
				></c-table-column>-->
				
				<c-table-column
					label="签批人姓名"
					name="sign_approval_user_realname"
				></c-table-column>
		
				<c-table-column
					label="签批时间"
					name="sign_approval_date"
					width="150"
				></c-table-column>
		
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="120"
				>
					<template v-slot="{data}">
						<c-table-button v-if="data.state == 0 || data.state == 4 " power="b_member_account_supdeduct_edit" @click="edit(data)">编辑</c-table-button>
						<c-table-button v-if="data.state == 0 || data.state == 4 " power="b_member_account_supdeduct_edit" @click="del(data)">删除</c-table-button>
						<c-table-button v-if="data.state == 1 || data.state == 2 || data.state == 3"  @click="navigateTo(`/member_account_supdeduct_detail/${data.id}`)">查看</c-table-button>
						<c-table-button v-if="data.state == 1" power="b_member_account_supdeduct_approval" @click="navigateTo(`/member_account_supdeduct_detail/${data.id}`)">审批</c-table-button>
						<c-table-button v-if="data.state == 2" power="b_member_account_supdeduct_sign" @click="navigateTo(`/member_account_supdeduct_detail/${data.id}`)">签批</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="uEdit" :title="editState ? '编辑货款补扣款' : '申请货款补扣款'" width="600" >
			<c-form ref="uForm">
				<c-form-item type="hidden" name="user_id"></c-form-item>
                <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone" required readonly @click="$refs.memberSelector.open()"></c-form-item>
                <c-form-item type="input" label="授权代码" name="login_name" readonly disabled></c-form-item>
                <c-form-item type="input" label="会员昵称" name="nick_name" readonly disabled></c-form-item>
				<c-form-item type="input" label="会员等级" name="user_level_name" readonly disabled></c-form-item>
				<c-form-item type="input" label="货款账户余额" name="account_balance" disabled></c-form-item>
				<c-form-item type="radio" label="补扣款类型" name="type" :options="Type" required></c-form-item>
				<c-form-item type="number" label="金额" name="money"  decimal="2" :limit="[0.01,999999]" required></c-form-item>
				<c-form-item type="image" label="凭证" name="voucher_img_url" file-word="" ></c-form-item>
				<c-form-item type="textarea" label="备注" name="remark" required></c-form-item>
				<c-form-item type="hidden" name="id"></c-form-item>
			</c-form>
			
			<template slot="button">
				<c-button size="m" @click="submit(0)">保存为草稿</c-button>
				<c-button size="m" @click="submit(2)">保存并提交</c-button>
				<c-button size="m" @click="$refs.uEdit.close()">取消</c-button>
			</template>
		</c-dialog>
		
		<member-selector ref="memberSelector" @resolve="selectMember"></member-selector>
	</page>
</template>

<script>
	import memberSelector from '@/components/service/member_selector.vue'  // 会员库
	export default {
		name: 'm_member_account_supdeduct',
		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			memberSelector
		},
		
		data() {
			return {
				account_type:1,
				stateName: {
					0: '草稿',
					// 1: '待审批',
					2: '待签批',
					3: '已完成',
					4: '驳回'
				},
				deduction_typeName: {
					1: '违规扣款',
					2: '其他'
				},
				State: [{
						name: '草稿',
						value: 0
					}/*,{
						name: '待审批',
						value: 1
					}*/,{
						name: '待签批',
						value: 2
					},{
						name: '已完成',
						value: 3
					},{
						name: '驳回',
						value: 4
					}
				],
				Type: [{
						name: '补款',
						value: "补款"
					},{
						name: '扣款',
						value: "扣款"
					}
				],
				Type2: [{
						name: '充值',
						value: "充值"
					},{
						name: '补款',
						value: "补款"
					},{
						name: '扣款',
						value: "扣款"
					}
				],
				editState: false
			}
		},
		
		mounted() {
			this.$refs.search.search();
			this.$bus.$on('member_account_supdeduct.update', data => {
				// 刷新列表
				this.$refs.table.update();
			});

		},
		
		methods: {
			searchHandle(data) {
				data.account_type = this.account_type;
				this.$refs.table.load({
					url: '/user/account/sup_deduct/list',
					data
				});
			},
			add(stop) {
				this.editState = false;
				this.$refs.uForm.clear();
				this.$refs.uEdit.open();
			},
			edit(val) {
				this.editState = true;
				this.$refs.uForm.set(val);
				this.$refs.uEdit.open();
			},
			del(val) {
				this.$confirm({
					text: '确定要删除【'+val.sup_deduct_number+'】吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/user/account/sup_deduct/remove',
							data: {id:val.id},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			selectMember(data) {
                console.log(data[0]);
				this.$refs.uForm.set({
					user_id: data[0].platform_user_id,
                    login_name: data[0].login_name,
					nick_name: data[0].nick_name,
					user_manage_mobilephone: data[0].user_manage_mobilephone,
                    user_level_name: data[0].user_level_name,
					account_balance: parseFloat(data[0].account_balance||0).toFixed(2)
				});
			},
			submit(state) {
				//stop();
				let submitUrl = '/user/account/sup_deduct/save';
				if(this.editState){
					submitUrl = '/user/account/sup_deduct/save';
				}
				this.$refs.uForm.submit({
					url: submitUrl,
					rule: {
						user_id: [{
							type: 'empty',
							word: '请选择会员'
						}],

						money: [{
							type: 'empty',
							word: '请输入金额'
						}],
						
						type: [{
							type: 'empty',
							word: '请选择补扣类型'
						}],

						remark: [{
							type: 'empty',
							word: '请填写备注信息'
						}]
					},
					dataFormatter: data => {
						data.account_type = this.account_type;
						data.state = state;
						return data;
					},
					success:(data,res) => {
						this.$message({
							text: '操作成功',
							icon: 'success'
						});
						this.$refs.table.update();
						this.$refs.uEdit.close();
					},
				});
			},
			
			//导入充值
			importSupdeduct() {
			    this.$confirm({
			        title: '导入充值提示',
			        buttonName: '选择文件',  // 确定按钮文字
			        text: '请使用标准模板进行导入 <a href="https://guimi-2025.oss-cn-hangzhou.aliyuncs.com/202509/20250904/b28744465f6ea1ef0514/%E8%B4%A7%E6%AC%BE%E5%85%85%E5%80%BC%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx" target="_blank" style="color:dodgerblue;">下载模板</a>',
			        resolve: () => {
			            this.uploadFile({
			                message: false,
			                success: data => {
			                    this.request({
			                        url: '/user/account/sup_deduct/import',
			                        data: {
			                            filePath: data.filePath
			                        },
			                        loading: true,
			                        timeout: false,
			                        success: (data, message) => {
			                            this.$refs.table.update();
			                            this.$confirm({
			                                title: '执行结果',
			                                text: message,  // 提示内容,
			                                buttonName: '确定',  // 确定按钮文字
			                                icon: 'success',
			                                cancelButton: false  // 是否显示取消按钮
			                            });
			                        },
                                    fail:(code,data,message) => {
                                        this.$confirm({
                                            title: '异常提示',
                                            text: message,  // 提示内容,
                                            buttonName: '知道了',  // 确定按钮文字
                                            icon: 'success',
                                            cancelButton: false  // 是否显示取消按钮
                                        });
                                        return false;
                                    }
			                    });
			                }
			            })
			        }
			    });
			}
		}
	}
</script>